import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/app/layers/ysn-nuxt/layouts/default.vue").then(m => m.default || m)),
  empty: defineAsyncComponent(() => import("/app/layers/ysn-nuxt/layouts/empty.vue").then(m => m.default || m))
}